<template>
  <div>
    <v-timeline dense align-top class="pt-0 mt-2 ticket-timeline">
      <v-timeline-item
        :color="ticketDetails.channel == 'email' ? '#03B6FC' : '#535C6C'"
        class="pb-0 ticket-timeline-item pb-3"
        fill-dot
        left
      >
        <template v-slot:icon>
          <div class="body-2 white--text">
            <span
              class="white--text pa-2 body-2 text-uppercase"
              v-if="contactSortName"
            >
              {{ contactSortName }}
            </span>
            <span v-else>
              <v-icon color="white"> mdi-account-outline</v-icon>
            </span>
          </div>
        </template>
        <v-card
          flat
          :color="ticketDetails.channel == 'email' ? '#EFF4F8' : '#EEEEEE'"
        >
          <div
            class="overflow-hidden d-flex"
            :class="
              ticketDetails.channel == 'email'
                ? 'blue-border'
                : 'grey-border'
            "
          >
            <div class="float-left">
              <div class="pt-2 overflow-hidden">
                <div class="body-1 float-left pl-5">
                  <v-tooltip top v-if="ticketDetails.contact_email">
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        v-on="on"
                        class="cursor-pointer flex-row text-capitalize max-width-200 text-truncate"
                      >
                        <span v-if="contactSortName">
                          {{ ticketDetails.contact_name }}
                        </span>
                        <span v-else>
                          {{ ticketDetails.contact_email }}
                        </span>
                      </div>
                    </template>
                    <span> {{ ticketDetails.contact_email }} </span>
                  </v-tooltip>
                </div>
                <div
                  class="float-left body-2 grey--text text--darken-2 pl-2 reported-via">
                  reported via
                  <span v-if="ticketDetails.channel"
                    >{{
                      ticketDetails.channel.replace("_", " ")
                        | upperCaseFirst
                    }}
                  </span>
                  {{ ticketDetails.created_at | formatDate }}
                </div>
              </div>
              <v-row
                no-gutters
                v-if="ticketDetails.to_emails"
                class="px-5 pb-2"
              >
                <template v-if="ticketDetails.to_emails.length">
                  <div class="width-100 d-flex">
                    <div>To:</div>
                    <div class="grey--text text--darken-2 pl-1">
                      <div
                        v-if="Array.isArray(ticketDetails.to_emails)"
                      >
                        <span
                          v-for="(
                            email, index
                          ) in ticketDetails.to_emails"
                          :key="index"
                        >
                          {{ index === 0 ? email : `, ${email}` }}
                        </span>
                      </div>
                      <div v-else>
                        {{ ticketDetails.to_emails }}
                      </div>
                    </div>
                  </div>
                </template>
                <template
                  v-if="
                    ticketDetails.cc_emails &&
                    ticketDetails.cc_emails.length
                  "
                >
                  <div class="width-100 d-flex pt-1">
                    <div>Cc:</div>
                    <div class="grey--text text--darken-2 pl-1">
                      <span
                        v-for="(
                          email, index
                        ) in ticketDetails.cc_emails"
                        :key="index"
                      >
                        {{ index === 0 ? email : `, ${email}` }}
                      </span>
                    </div>
                  </div>
                </template>
            </v-row>
            </div>
            <v-spacer></v-spacer>
            <div class="float-right">
                <div class="cursor-pointer pr-2 mt-2" 
                  v-if="ticketDetails.status !== 'closed' 
                  && !ticketAccess.contactRemoved && !ticketAccess.deleted" 
                  @click="showReplySection('forward_ticket','')">
                    <v-tooltip left attach>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon text v-bind="attrs" v-on="on">
                          <v-icon size="24px">mdi-arrow-right-top</v-icon>
                        </v-btn>
                      </template>
                      <span> Forward </span>
                    </v-tooltip>
                </div>
            </div>
          </div>
          <v-card-text class="mb-5 px-5 description-box">
            <div>
              <p
                class="py-5 body-1 black--text mb-8"
                v-html="ticketDetails.description"
              ></p>

              <ShowAttachments
                v-if="ticketDetails"
                :fileData="ticketDetails"
              >
              </ShowAttachments>
            </div>
          </v-card-text>
        </v-card>
      </v-timeline-item>
      <v-timeline-item
        class="ticket-timeline-item pt-2"
        v-for="(item, index) in listOfActivities"
        :key="index"
        fill-dot
        left
        :icon="item.performer.type == 'system' ? 'mdi-cog' : ''"
        :color="getIconColor(item)"
      >
        <template v-slot:icon v-if="item.performer.type !== 'system'">
          <div class="body-2 white--text text-uppercase">
            {{ timeLineShortName(item.performer.name) }}
          </div>
        </template>
        <template v-if="item.action.type == 'comment'">
          <v-card
            flat
            :color="getCardColor(item.action.content)"
            outlined
            :class="cardColorClass(item)"
          >
            <div
              class="overflow-hidden d-flex"
              :class="item.action.content.incoming ? 'blue-border' : 'grey-border'"
              v-if="item.action.content.comment_type !== 'note'"
            >
              <div class="float-left">
                <div
                  class="d-flex flex-row text-capitalize pl-5 pr-2"
                  :class="item.action.content.comment_type !== 'note' ? 'mt-2' : ''"
                >
                  <v-tooltip top v-if="item.action.content.from_email">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="cursor-pointer">
                        <!-- <span v-if="item.incoming"> {{ ticketDetails.contact_name }} </span> -->
                        <span v-if="item.action.content.user">
                          {{
                            `${
                              item.action.content.user.first_name
                                ? item.action.content.user.first_name
                                : ""
                            } ${
                              item.action.content.user.last_name
                                ? item.action.content.user.last_name
                                : ""
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                    <span> {{ item.action.content.from_email }} </span>
                  </v-tooltip>

                  <div
                    class="float-left body-2 pl-2 grey--text text--darken-2 pt-2px text-lowercase">
                    <span> {{item.action.content.comment_type == 'forward' ? "forwarded": "replied"}}</span> on <span class="text-capitalize">{{ item.action.content.created_at | formatDate }}</span>
                  </div> 
                </div>
                <div
                  class="mb-2 px-5"
                  v-if="
                    item.action.content.to_emails &&
                    item.action.content.to_emails.length &&
                    item.action.content.comment_type !== 'note'
                  "
                >
                  <div class="d-flex width-100" v-if="item.action.content.comment_type !== 'forward'">
                    <span class="mr-1"> To: </span>
                    <div class="grey--text text--darken-2">
                      {{ item.action.content.to_emails.toString().split(',').join(', ') }}
                    </div>
                  </div>
                  <div
                  class="width-100 pt-1"
                    v-if="
                      item.action.content.cc_emails &&
                      item.action.content.cc_emails.length
                    "
                  >
                    Cc:<span class="grey--text text--darken-2 word-break">
                      <template
                        v-for="(email, index) in item.action.content.cc_emails"
                      >
                        <span v-if="index >= 1" :key="index">,</span> {{ email }}
                      </template>
                    </span>
                  </div>
                  <!-- <v-divider></v-divider> -->
                </div>
              </div>
              <v-spacer></v-spacer>
              <div class="float-right pt-2 pr-2">
                <div class="cursor-pointer pb-1" 
                  v-if="item.action.content.comment_type === 'forward'"
                  @click="displaySection(item.action.content.comments_thread_id)">
                  <v-tooltip left  attach>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon text v-bind="attrs" v-on="on">
                        <v-icon size="22px">mdi-forum-outline</v-icon>
                      </v-btn>
                    </template>
                    <span> View threads </span>
                  </v-tooltip>
                </div>
                <div class="cursor-pointer" 
                  v-else-if="ticketDetails.status !== 'closed' 
                  && !ticketAccess.contactRemoved && !ticketAccess.deleted"
                  @click="showReplySection('forward',item.id)">
                  <v-tooltip left attach>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon text v-bind="attrs" v-on="on">
                        <v-icon size="24px">mdi-arrow-right-top</v-icon>
                      </v-btn>
                    </template>
                    <span> Forward </span>
                  </v-tooltip>
                </div>
              </div>
              
            </div>
            <v-col
                cols="12"
                v-if="item.action.content.email_errors"
                class="d-flex mb-2"
              >
                <v-alert
                  icon="mdi-alert-circle-outline"
                  dense
                  color="#FFCDD2"
                  class="width-100 body-2 mb-0 pa-1 pl-3 error-icon-color"
                >
                  <b class="pr-1">Message</b> undelivered to recipient
                  <span
                    v-for="(item, key, index) in item.action.content.email_errors"
                    :key="item"
                  >
                    <span> {{index == 0 ? key : `, ${key}`}} </span>
                  </span>.
                </v-alert>
              </v-col>
            <div
              v-if="item.action.content.comment_type === 'note'"
              class="d-flex justify-space-between note-header px-5 py-4 body-2"
            >
              <div>
                <b v-if="item.action.content.user">
                  {{
                    `${
                      item.action.content.user.first_name
                        ? item.action.content.user.first_name
                        : ""
                    } ${
                      item.action.content.user.last_name
                        ? item.action.content.user.last_name
                        : ""
                    }`
                  }}
                </b>
                <b v-else> {{ agenName }} </b>
                <!-- date needs to be formatted before comparison to remove the milliseconds from timestamp -->
                <span>
                  {{
                    getFormattedDate(item.action.content.updated_at) ===
                    getFormattedDate(item.action.content.created_at)
                      ? "added"
                      : "updated"
                  }}
                </span>
                an internal note -
                <span class="grey--text text--darken-2">
                  {{ item.action.content.updated_at | formatDate }} 
                </span>
              </div>
              <div>
                <v-icon
                  class="cursor-pointer"
                  size="20"
                  id="edit-note"
                  v-track="'edit-note-icon-click'"
                  @click="singleItem(item.action.content, index)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  class="cursor-pointer ml-2"
                  size="20"
                  id="delete-note"
                  v-track="'delete-note-icon-click'"
                  @click="toggleDeleteDialog(item.action.content)"
                  >delete
                </v-icon>
              </div>
            </div>
            <v-card-text class="px-5 reply-message">
              <div v-if="!(currentIndex == index && editButton)">
                <div>
                  <div
                    class="body-1"
                    v-html="toggleReplyChain(item.action.content)"
                  ></div>

                  <!--- quoted text--->
                  <div
                    class="chain-messsages mt-2"
                    v-if="checkToShowThreadIcon(item.action.content, index)"
                  >
                     <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            v-track="'hide-reply-chain-click'"
                            @click="createReplyChain(item.action.content, index) "
                            >mdi-dots-horizontal</v-icon
                          >
                        </template>
                        <span class="caption" >
                           {{index == currentCommentIndex && toggleCommentChain 
                           ? 'Hide quoted text': 'Show quoted text' }}
                        </span>
                      </v-tooltip>
                    <div
                      class="chain-body mt-2"
                      v-if="index == currentCommentIndex && toggleCommentChain"
                    >
                      <div
                        class="service-cloud-quote"
                        v-html="commentChainHtml"
                      ></div>
                    </div>
                  </div>
                </div>

                <div v-if="item.action.content.comment_type !== 'forward'">
                  <h3
                    class="body-1 mt-2"
                    v-if="item.action.content.attachment_info.length"
                  >
                    <span
                      class="
                        secondary--font
                        font-weight-600
                        black--text
                      "
                    >
                      Attachments ({{
                        item.action.content.attachment_info.length
                      }})
                    </span>
                  </h3>
                  <ShowAttachments
                    :fileData="item.action.content"
                    :key="loadComponent"
                  >
                  </ShowAttachments>
                </div>
              </div>
              <div v-if="currentIndex == index && editButton">
                <div
                  class="
                    d-flex
                    justify-space-between
                    flex-wrap
                    font-weight-medium
                  "
                >
                  <span class="pa-2">Internal Note </span
                  ><span>
                    <FileUploader
                      page="ckeditor"
                      @saveAttachment="saveAttachment"
                    >
                    </FileUploader>
                  </span>
                </div>

                <div class="edit-internal-note">
                  <Ckeditor
                    @update="getEditorHTML"
                    :body="editorHTML"
                    action="edit-note"
                  >
                  </Ckeditor>
                </div>
                <v-col
                  cols="12"
                  v-if="dropedFiles.length || attachmentFiles.length"
                  id="attachment-section"
                >
                  <h6 class="text-subtitle-1">
                    <span class="secondary--font black--text">
                      Attachments ({{
                        dropedFiles.length + attachmentFiles.length
                      }})
                    </span>
                  </h6>
                </v-col>
                <v-col cols="12" v-if="dropedFiles.length">
                  <template v-for="(file, index) in dropedFiles">
                    <v-chip
                      color="#CBDAE8"
                      :key="index"
                      class="ml-0 ma-2 mr-3"
                      v-track="'remove-selected-attachment'"
                      close
                      @click:close="removeAttchment(file, 'new')"
                    >
                      <span class="text-truncate width-300">
                        {{ file.name }}
                      </span>
                    </v-chip>
                  </template>
                </v-col>
                <v-col cols="12" class="pt-0" v-if="attachmentFiles.length">
                  <template v-for="(file, index) in attachmentFiles">
                    <v-chip
                      color="#CBDAE8"
                      :key="index"
                      class="ml-0 ma-2 mr-3"
                      v-track="'remove-existing-attachment'"
                      close
                      @click:close="removeAttchment(file, 'old')"
                    >
                      <span class="text-truncate width-300">{{ file.file_name }}
                      </span>
                    </v-chip>
                  </template>
                </v-col>
                <div class="pa-4 note-border">
                  <span class="pr-2">
                    <v-btn
                      outlined
                      class="font-weight-bold"
                      v-track="'cancel-comment-section-btn'"
                      @click="confirmCancel"
                      >cancel</v-btn
                    >
                  </span>
                  <span>
                    <v-btn dark class="font-weight-bold"
                    v-track="'update-internal-note'"
                    @click="updateNote(item)"
                      >Update</v-btn
                    >
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </template>

        <!----ticket history ---->
        <v-card color="#EEEEEE" class="history-card" width="100%" flat>
          <div
            v-if="
              item.action.type == 'update' ||
              item.action.type == 'create' ||
              item.action.type == 'delete'
            "
          >
            <div
              class="d-flex flex-row text-capitalize px-5 pt-2"
              :class="{ 'mt-2': item.action.type === 'update' || item.action.type === 'create' }"
            >
              <v-tooltip top v-if="item.performer.email">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" class="cursor-pointer">
                    <span
                      v-if="
                        item.performer.type == 'agent' ||
                        item.performer.type == 'contact'
                      "
                    >
                      {{ item.performer.name }}
                    </span>
                  </div>
                </template>
                <span> {{ item.performer.email }} </span>
              </v-tooltip>
              <div v-else>
                System
                <span class="text-lowercase grey--text text--darken-2">
                  executed an automation on
                </span>
              </div>

              <div class="float-left body-2 pl-2 pt-2px grey--text text--darken-2">
                 {{ item.created_at | formatDate }}
              </div>
            </div>
            <v-divider class="mt-2"></v-divider>
            <v-card-text class="inline-block-span px-5">
              <div
                v-for="(subItem, key, index) in item.action.content"
                :key="index"
              >
               <template v-if="key ==='deleted_at'">
                Ticket deleted by {{ item.performer.name }}
                </template>
                <template v-if="key !== 'closed_reason' && key !=='deleted_at'">
                  <span v-if="key == 'ticket_type_name'"> Type name </span>
                  <span v-else-if="key == 'contact_name'"> Contact </span>
                  <span v-else-if="key == 'agent_name'"> Agent </span>
                  <span v-else-if="key == 'tags'"></span>
                  <span v-else>
                    {{
                      key == "attachments"
                        ? "attachment"
                        : key.replace(/_/g, " ") | upperCaseFirst
                    }}
                  </span>
                  <span v-if="item.action.type !== 'delete' && key!='tags' && subItem"> updated</span>
                  <span v-else-if="key == 'tags'">{{ subItem | upperCaseFirst }}</span>
                  <span v-else-if="!subItem">unassigned</span>
                  <span v-else> deleted </span>
                  <span
                    v-if="
                      key !== 'subject' &&
                      key !== 'description' &&
                      key !== 'attachments' &&
                      key !== 'tags' &&
                      subItem
                    "
                  >
                    <span>
                      to
                      {{
                        subItem.toString().replace(/_/g, " ") | upperCaseFirst
                      }}</span
                    >
                  </span>
                </template>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </v-timeline-item>
      <v-timeline-item fill-dot
        v-if="ticketDetails.status !== 'closed'"
        class="white--text pb-0 ticket-timeline-item"
        color="#545C6C">
          <template v-slot:icon>
            <div class="body-2 white--text text-uppercase">
              {{ agentShortName }}
            </div>
          </template>
      </v-timeline-item>
    </v-timeline>

    <div v-if="ticketDetails.status === 'closed'">
      <div class="body-2 pl-4 grey--text text--darken-2 ml-12">
        This ticket has been closed on
        {{ ticketDetails.updated_at | formatDate }}
      </div>
    </div>
    <v-dialog v-model="deleteDialog" max-width="500">
      <v-card class="pa-2 py-3">
        <v-card-title class="text-h6 font-weight-600">
          <span class="secondary--font"> Delete Internal Note </span>
        </v-card-title>
        <v-card-text class="body-2">
          Are you sure you want to delete this internal note?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="cancel-delete"
            text
            @click="deleteDialog = false"
            class="font-weight-bold"
            v-track="'cancel-deleting-note-btn'"
          >
            Cancel
          </v-btn>
          <v-btn
            id="confirm-delete"
            dark
            @click="confirmDelete()"
            class="font-weight-bold"
            v-track="'confirm-delete-note'"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="hidden-comment" class="d-none"></div>
  </div>
</template>

<script>
import { $tickets } from "@/services/Index";
import ShowAttachments from "@/components/tickets/reply/ShowAttachments";
import FileUploader from "@/components/file_uploader/UploadFile";
import Ckeditor from "@/components/ckeditor/Editor";
import { attachmentfileactionMixin } from "@/mixins/attachmentFileAction.js";
import { commentMixin } from "@/mixins/comments.js";

export default {
  props: {
    ticketDetails: {
      type:[Object, Array],
      default: ()=> ({})
    }, 
    activities: {
      type: Boolean,
      default: false
    },
    ticketAccess: {
      type: Object,
      default: ()=> ({})
    },
  },
  mixins: [attachmentfileactionMixin,commentMixin],
  watch: {
    activities () {
      this.getAllActivities(this.$route.params.id);
    }
  },
  components: {
    ShowAttachments,
    FileUploader,
    Ckeditor,
  },
  data() {
    return {
      listOfComments: [],
      listOfActivities: [],
      agenName: "Sam Jones",
      editorHTML: "",
      editButton: false,
      currentIndex: null,
      dropedFiles: [],
      deleteDialog: false,
      selectedData: [],
      deleteAttachmentIds: [],
      loadComponent: false,
      attachmentFiles: [],
      chainBody: "",
      threadComments: [],
    };
  },

  mounted() {
    //this.getAllComments(this.$route.params.id);
    this.getAllActivities(this.$route.params.id);
  },

  computed:{

    agentShortName() {
      const username = this.$store.getters["auth/username"] || {};
      let shortName = "SJ";

      if (username.firstName && username.lastName) {
        shortName = `${username.firstName.charAt(0)}${username.lastName.charAt(0)}`;
      } else if (username.firstName) {
        shortName = username.firstName.charAt(0);
      }

      return shortName;
    },

    contactSortName() {
      let shortName = "";
      if (this.ticketDetails.contact_name) {
        let name = this.ticketDetails.contact_name.split(" ");
        if (name.length >= 2) {
          shortName = name[0].charAt(0) + name[1].charAt(0);
        } else {
          shortName = name[0].charAt(0);
        }
      }
      return shortName;
    },
  },
  methods: {
    getFormattedDate(value) {
      return this.$options.filters.formatDate(
          value,
          "lll"
        );
    },
    timeLineShortName(userName) {
      let name = "";
      name = userName.split(" ");
      name = name[0].charAt(0) + name[1].charAt(0);
      return name;
    },

    getEditorHTML(htmlData) {
      this.editorHTML = htmlData;
    },
    /** method to open delete dialog */
    toggleDeleteDialog(data) {
      this.deleteDialog = true;
      this.selectedData = data;
    },
   
    /** get all activities ticket history of a single ticket from API's */
    async getAllActivities(ticketId, commentType = "") {
      let payload = {
        activities: this.activities
      };
      try {
        const response = await $tickets.getActivities(ticketId, { params: payload }, {});
        if (response.data) {
          this.listOfActivities = response.data;
          this.loadComponent = !this.loadComponent;
          this.$emit("commentLoaded", commentType, this.listOfActivities);
          this.$store.dispatch("tickets/listOfComments", [
            this.listOfActivities,
          ]);
        }
      } catch (error) {
        console.log("error==", error);
      }
    },

    singleItem(data, index) {
      this.currentIndex = index;
      this.editorHTML = data.body;
      this.editButton = true;
      this.attachmentFiles = data.attachment_info;
      this.dropedFiles = [];
    },
    /** updateNote Note API request. */
    async updateNote(item) {
      item.body = this.editorHTML;
      if (this.editorHTML !== "") {
        let payload = null;
        let commentId = item.id;
        let data = {
          ticket_id: item.ticket_id,
          // agent_id: item.agent_id ? item.agent_id : "",
          id: item.id,
          comment_type: "note",
          body: this.editorHTML,
          delete_attachment_ids: this.deleteAttachmentIds,
        };
        payload = data;
        let config = {};
        const formdata = new FormData();
        if (this.dropedFiles.length || this.deleteAttachmentIds.length) {
          config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
          let commentData = data;
          for (var key in commentData) {
            if (key == "delete_attachment_ids") {
              commentData[key].forEach((item) => {
                formdata.append("delete_attachment_ids[]", item);
              });
            } else {
              formdata.append(key, commentData[key]);
            }
          }
          this.dropedFiles.forEach((file) => {
            formdata.append("attachments[]", file);
          });
          payload = formdata;
        }

        try {
          const response = await $tickets.updateNote(
            commentId,
            payload,
            config
          );
          if (response.data) {
            this.editButton = false;
            this.dropedFiles = [];
            this.deleteAttachmentIds = [];
            this.getAllActivities(this.$route.params.id, "note");

            this.$store.dispatch("ui/snackbar", [
              {
                title: "",
                message: `Internal note updated`,
                type: "success",
              },
            ]);
          }
        } catch (error) {
         // Log any errors from the try block or API
          console.error('An error occurred:', error);
        }
      }
    },

    confirmCancel() {
      this.editButton = false;
    },

    /** deleting selected Internal Note API request */
    async confirmDelete() {
      let payload = {
        id: this.selectedData.id,
      };
      try {
        const response = await $tickets.deleteNote(payload, {});
        if (response.data) {
          this.deleteDialog = false;
          this.getAllActivities(this.$route.params.id);

          this.$store.dispatch("ui/snackbar", [
            {
              title: "Delete Note",
              message: `Selected note has been deleted.`,
              type: "success",
            },
          ]);
        }
      } catch (error) {
        this.deleteDialog = false;
      }
    },

    /** this function seperate out main message from quoted text */
    toggleReplyChain(comment, index) {
      let actualMessage = "";
      if (comment.comment_type === 'forward') {
        actualMessage = "Forwarded the ticket to " + comment.to_emails.join(', ');
      } 
      else {
        let planer = require("planer");
        actualMessage = planer.extractFrom(comment.body,"text/html",window.document);
      }
      return actualMessage;
    },

    getCardColor(comment) {
      let cardColor = "#EEEEEE";
      if (comment.incoming && comment.comment_type == "reply") {
        cardColor = "#EFF4F8";
      } else if (comment.comment_type == "note") {
        cardColor = "#FFF1CC";
      }
      else if (comment.comment_type == "forward") {
        cardColor = "#FFFFF";
      }
      return cardColor;
    },

    getIconColor(item) {
      let iconColor = "#535C6C";
      if (item.performer.type == "contact") {
        let comment = item.action.content;
        if (comment.incoming && comment.comment_type == "reply") {
          iconColor = "#03B6FC";
        }
      } else if (item.performer.type == "system") {
        iconColor = "#03B6FC";
      }

      return iconColor;
    },

    showReplySection(type ,commentId){
      this.$emit("show-replysection", type, commentId)
    },
    displaySection(threadId) {
      this.$emit("showThreadSection", threadId);
    },
    
    cardColorClass(item) {
      const commentTypeClassMap = {
        'reply': 'reply-card',
        'note': 'internal-note',
        'forward': 'forward-card'
      };
      return commentTypeClassMap[item.action.content.comment_type] || 'default-card';
    }
  },
};
</script>
<style>
.note-header {
  border-bottom: 1px solid #ffcc33 !important;
}

blockquote.service-cloud-quote {
  padding-left: 10px;
  border-left: 1px solid #ccc;
  margin-left: 10px;
}

.service-cloud-quote blockquote {
  border-left: 1px solid #ccc;
  padding-left: 10px;
  margin-left: 5px;
}
.service-cloud-quote > p {
  display: none !important;
}
.error-icon-color .v-icon {
  color: #b71c1c !important;
  font-size: 20px !important;
  margin-right: 6px !important;
}
.edit-internal-note .ck.ck-content {
  height: 200px;
}
.width-300{
  max-width: 300px;
}
.pt-2px{
  padding-top:2px;
}
</style>
